export const PRIVACY_MAP = {
  0: "public",
  1: "private",
  2: "onlyme",
}

export const FILE_TYPES = [".ppt", ".pdf", ".doc", ".pptx", ".ppsx", ".potx", ".docx", ".dotx"]
